import React from 'react';
export function LegendaryPokemon() {
  return <div className="flex" data-id="element-172">
      <img src="https://www.pokemon.com/static-assets/content-assets/cms2/img/pokedex/full/1000.png" alt="Koraidon" className="w-12 h-12 object-contain opacity-80" data-id="element-173" />
      <img src="https://www.serebii.net/scarletviolet/pokemon/new/999.png" alt="Miraidon" className="w-12 h-12 object-contain opacity-80" data-id="element-174" />
    </div>;
}